import React, { useState, useEffect, useRef } from 'react';
import utils from '../app/utils';
import Step from './Step';
import SubStep from './SubStep';
import StepRadioGroup from './StepRadioGroup';
import GenericButton from './GenericButton';
import StepRadioButton from './StepRadioButton';
import constants from '../app/constants';
import { useSelector, useDispatch } from 'react-redux';
import {
    setSelectedOptions,
    setEditColorLens,
    setTreatmentOptions,
    setTreatmentOptionsPackages,
    setExtraTreatment,
    setGoToTreatment,
    setIsLensGaming,
    setProductImage,
    setProductImageOld,
    setImageErrorMessage,
    setLensErrorMessage,
} from '../app/mainSlice';
import { scroller } from 'react-scroll';
import { isMobile } from 'react-device-detect';
import axios from 'axios';
/**
 * @param props.isLearnMore
 * @param props.showOnly
 */
const TreatmentStep = props => {
    const dispatch = useDispatch();
    const labels = useSelector(state => state.main.labels);
    const data = useSelector(state => state.main.data);
    const selectedOptions = useSelector(state => state.main.selectedOptions);
    const editColorLens = useSelector(state => state.main.editColorLens);
    const treatmentOptions = useSelector(state => state.main.treatmentOptions);
    const treatmentOptionsPackages = useSelector(state => state.main.treatmentOptionsPackages);
    const baseLensPackage = useSelector(state => state.main.baseLensPackage);
    const isInsuranceEnabled = useSelector(state => state.main.isInsuranceEnabled);
    const isInsuranceLoading = useSelector(state => state.main.isInsuranceLoading);
    const currentStep = useSelector(state => state.main.currentStep);
    const [currentLensPackage, setCurrentLensPackage] = useState(null);
    const [isBlueLightOnly, setIsBlueLightOnly] = useState(false);
    const isLearnMoreModalOpen = useSelector(state => state.main.isLearnMoreModalOpen);
    const currentTreatment = useSelector(state => state.main.currentTreatment);
    const currentTreatmentSelected = useSelector(state => state.main.currentTreatmentSelected);
    const isLensGaming = useSelector(state => state.main.isLensGaming);
    const blueDisclaimer = useSelector(state => state.main.blueDisclaimer);
    const selectedColorOption = useSelector(state => state.main.selectedColorOption);
    const selectedPrescriptionObject = useSelector(state => state.main.selectedPrescriptionObject);
    const productImageOld = useSelector(state => state.main.productImageOld);
    const brandSelected = useSelector(state => state.main.brandSelected);
    const isGVP = useSelector(state => state.main.isGVP);

    const [sourceColor, setSourceColor] = useState(null);

    useEffect(() => {
        // Update totals on currentLensPackage change or insurance enabled
        if (currentLensPackage !== null && props.isOpen) {
            props.handleUpdateTotalPriceAndDiscount(currentLensPackage);
        }
    }, [currentLensPackage, isInsuranceEnabled]);

    useEffect(() => {
        // When insurance is enabled and data packages are updated after
        // retrieving insurance discount update the currentLensPackage
        if (isInsuranceEnabled) {
            // Update treatmentOptionsPackages with insurance prices
            if (treatmentOptionsPackages && Object.keys(treatmentOptionsPackages).length > 0) {
                let tempTreatmentOptionsPackages = utils.deepCopy(treatmentOptionsPackages);

                Object.entries(tempTreatmentOptionsPackages).forEach(tempTreatmentOptionPackage => {
                    const tempTreatmentOptionPackageKey = tempTreatmentOptionPackage[0];
                    const tempTreatmentOptionPackageValue = tempTreatmentOptionPackage[1];

                    if (tempTreatmentOptionPackageValue.lensPackage.insPrice == null) {
                        const updatedPackage = data.packages.filter(currentPackage => {
                            if (
                                currentPackage.lensPackage.upc ==
                                tempTreatmentOptionPackageValue.lensPackage.upc
                            ) {
                                return currentPackage;
                            }
                        })[0];

                        if (updatedPackage !== null) {
                            tempTreatmentOptionsPackages[
                                tempTreatmentOptionPackageKey
                            ] = updatedPackage;
                        }
                    }
                });

                dispatch(setTreatmentOptionsPackages(tempTreatmentOptionsPackages));
            }

            if (currentLensPackage !== null) {
                if (currentLensPackage.lensPackage.insPrice == null) {
                    const currentPackageWithUpdatedPrices = data.packages.reduce(
                        (prevPackage, filteredPackage) => {
                            return filteredPackage.lensPackage.upc ==
                                currentLensPackage.lensPackage.upc
                                ? filteredPackage
                                : prevPackage;
                        },
                        data.packages[0]
                    );

                    setCurrentLensPackage(currentPackageWithUpdatedPrices);
                } else {
                    setCurrentLensPackage(currentLensPackage);
                }
            }
        }
    }, [data.packages]);

    const checkTreatmentIncluded = (packages, treatment, value) => {
        let isIncluded = true;
        for (let i = 0; i < packages.length; i++) {
            if (packages[i].lensPackage[treatment] !== value) {
                isIncluded = false;
                break;
            }
        }
        return isIncluded;
    };

    const treatmentDataDescription = treatmentOptions => {
        let treatmentDataDescriptionValue = '';

        if (treatmentOptions !== null) {
            if (treatmentOptions.polar !== undefined) {
                treatmentDataDescriptionValue += treatmentOptions.polar;
            }
            if (treatmentOptions.antiReflective !== undefined) {
                treatmentDataDescriptionValue += treatmentOptions.antiReflective;
            }
            if (treatmentOptions.transition !== undefined) {
                treatmentDataDescriptionValue += treatmentOptions.transition;
            }
            if (treatmentOptions.blueLight !== undefined) {
                treatmentDataDescriptionValue += treatmentOptions.blueLight;
            }
            if (treatmentOptions.colorCategory !== undefined) {
                treatmentDataDescriptionValue += treatmentOptions.colorCategory;
            }
            if (treatmentOptions.color !== undefined) {
                treatmentDataDescriptionValue += treatmentOptions.color;
            }
        }

        return treatmentDataDescriptionValue;
    };

    const getMinTreatmentOptionPackage = (treatmentOptionKey, treatmentOptionValue) => {
        let minTreatmentOptionPackage = null;
        let tempTreatmentOptionPackages = [];

        tempTreatmentOptionPackages = data.packages.filter(currentPackage => {
            if (
                selectedOptions &&
                selectedOptions.type &&
                currentPackage.lensPackage.type == selectedOptions.type &&
                selectedOptions.brand &&
                currentPackage.lensPackage.brand == selectedOptions.brand &&
                selectedOptions.thickness &&
                currentPackage.lensPackage.thickness == selectedOptions.thickness &&
                utils.hasValidPrescription(currentPackage, selectedPrescriptionObject) &&
                currentPackage.lensPackage[treatmentOptionKey] == treatmentOptionValue
            ) {
                return currentPackage;
            }
        });

        if (tempTreatmentOptionPackages.length > 0) {
            minTreatmentOptionPackage = tempTreatmentOptionPackages.reduce(
                (prevPackage, currentPackage) => {
                    let currentListPrice = parseFloat(currentPackage.lensPackage.listPrice);
                    let prevListPrice = parseFloat(prevPackage.lensPackage.listPrice);

                    if (
                        isGVP &&
                        !isInsuranceEnabled &&
                        currentPackage.frame.promoType === constants.promoTypes.GVP
                    ) {
                        currentListPrice =
                            parseFloat(props.config.data.frame.listPrice) +
                            parseFloat(currentPackage.lensPackage.listPrice);
                        prevListPrice =
                            parseFloat(props.config.data.frame.listPrice) +
                            parseFloat(prevPackage.lensPackage.listPrice);
                    }

                    return currentListPrice < prevListPrice ? currentPackage : prevPackage;
                }
            );
        }

        return minTreatmentOptionPackage;
    };

    const getPriceObject = (
        treatmentPackage,
        treatmentOption,
        treatmentOptionValue,
        isInsuranceEnabled
    ) => {
        let priceObject = null;

        if (
            treatmentOptionsPackages == null ||
            treatmentOptionsPackages[treatmentOption] == null ||
            treatmentOptions == null ||
            treatmentOptions[treatmentOption] !== treatmentOptionValue
        ) {
            // If treatmentOption is not currently selected
            if (treatmentOptions == null || treatmentOptionsPackages == null) {
                //treatmentOptions/treatmentOptionsPackages == null -> from other steps, delta is the result of filteredPackage(pack) - baseLensPackage
                if (baseLensPackage) {
                    if (isInsuranceEnabled) {
                        if (
                            baseLensPackage.lensPackage.insPrice !== null &&
                            treatmentPackage.lensPackage.insPrice !== null
                        ) {
                            priceObject = {
                                delta:
                                    parseFloat(treatmentPackage.lensPackage.insPrice) -
                                    parseFloat(baseLensPackage.lensPackage.insPrice),
                                framePrice: parseFloat(treatmentPackage.frame.insPrice),
                                lensPrice: parseFloat(treatmentPackage.lensPackage.insPrice),
                            };
                        } else {
                            // Insurance fallback to list price
                            priceObject = {
                                delta:
                                    parseFloat(treatmentPackage.lensPackage.listPrice) -
                                    parseFloat(baseLensPackage.lensPackage.listPrice),
                                framePrice: parseFloat(props.config.data.frame.listPrice),
                                lensPrice: parseFloat(treatmentPackage.lensPackage.listPrice),
                            };
                        }
                    } else {
                        priceObject = {
                            delta:
                                parseFloat(treatmentPackage.lensPackage.offerPrice) -
                                parseFloat(baseLensPackage.lensPackage.offerPrice),
                            framePrice: parseFloat(treatmentPackage.frame.offerPrice),
                            lensPrice: parseFloat(treatmentPackage.lensPackage.offerPrice),
                        };
                    }
                }
            } else {
                // Delta is the result of filteredPackage(pack) - currentPackage
                if (currentLensPackage) {
                    if (isInsuranceEnabled) {
                        if (
                            currentLensPackage.lensPackage.insPrice !== null &&
                            treatmentPackage.lensPackage.insPrice !== null
                        ) {
                            priceObject = {
                                delta:
                                    parseFloat(treatmentPackage.lensPackage.insPrice) -
                                    parseFloat(currentLensPackage.lensPackage.insPrice),
                                framePrice: parseFloat(treatmentPackage.frame.insPrice),
                                lensPrice: parseFloat(treatmentPackage.lensPackage.insPrice),
                            };
                        } else {
                            // Fallback
                            priceObject = {
                                delta:
                                    parseFloat(treatmentPackage.lensPackage.listPrice) -
                                    parseFloat(currentLensPackage.lensPackage.listPrice),
                                framePrice: parseFloat(props.config.data.frame.listPrice),
                                lensPrice: parseFloat(treatmentPackage.lensPackage.listPrice),
                            };
                        }
                    } else {
                        priceObject = {
                            delta:
                                parseFloat(treatmentPackage.lensPackage.offerPrice) -
                                parseFloat(currentLensPackage.lensPackage.offerPrice),
                            framePrice: parseFloat(treatmentPackage.frame.offerPrice),
                            lensPrice: parseFloat(treatmentPackage.lensPackage.offerPrice),
                        };
                    }
                }
            }
        } else {
            if (isGVP) {
                // If GVP return full prices
                if (isInsuranceEnabled) {
                    if (treatmentPackage.lensPackage.insPrice !== null) {
                        priceObject = {
                            delta: null,
                            framePrice: parseFloat(treatmentPackage.frame.insPrice),
                            lensPrice: parseFloat(treatmentPackage.lensPackage.insPrice),
                        };
                    } else {
                        // Fallback
                        priceObject = {
                            delta: null,
                            framePrice: parseFloat(props.config.data.frame.listPrice),
                            lensPrice: parseFloat(treatmentPackage.lensPackage.listPrice),
                        };
                    }
                } else {
                    priceObject = {
                        delta: null,
                        framePrice: parseFloat(treatmentPackage.frame.offerPrice),
                        lensPrice: parseFloat(treatmentPackage.lensPackage.offerPrice),
                    };
                }
            } else {
                // Calculate delta prices (treatmentPackage1 - treatmentPackage2)
                let treatmentPackage1 = null;
                let treatmentPackage2 = baseLensPackage;

                // If treatment option is selected, get the original package
                if (treatmentOptionsPackages[treatmentOption]) {
                    treatmentPackage1 = treatmentOptionsPackages[treatmentOption];
                }

                if (treatmentPackage1 == null) {
                    // If treatment option has not been selected,
                    // use the current selected package as treatmentPackage1
                    let hasbaseLensPackage = false;

                    const currentFilteredPackages = data.packages.filter(currentPackage => {
                        if (
                            selectedOptions &&
                            treatmentOptions &&
                            selectedOptions.type &&
                            currentPackage.lensPackage.type == selectedOptions.type &&
                            selectedOptions.brand &&
                            currentPackage.lensPackage.brand == selectedOptions.brand &&
                            selectedOptions.thickness &&
                            currentPackage.lensPackage.thickness == selectedOptions.thickness &&
                            (!treatmentOptions.polar ||
                                treatmentOptions.polar == currentPackage.lensPackage.polar) &&
                            (!treatmentOptions.antiReflective ||
                                treatmentOptions.antiReflective ==
                                    currentPackage.lensPackage.antiReflective) &&
                            (!treatmentOptions.blueLight ||
                                treatmentOptions.blueLight ==
                                    currentPackage.lensPackage.blueLight) &&
                            (!treatmentOptions.transition ||
                                treatmentOptions.transition ==
                                    currentPackage.lensPackage.transition) &&
                            (!treatmentOptions.colorCategory ||
                                treatmentOptions.colorCategory ==
                                    currentPackage.lensPackage.colorCategory) &&
                            (!treatmentOptions.color ||
                                treatmentOptions.color == currentPackage.lensPackage.color) &&
                            utils.hasValidPrescription(currentPackage, selectedPrescriptionObject)
                        ) {
                            if (currentPackage.lensPackage.isBaseLens) {
                                hasbaseLensPackage = true;
                            }

                            return currentPackage;
                        }
                    });

                    if (hasbaseLensPackage) {
                        treatmentPackage1 = baseLensPackage;
                    } else {
                        let tempMinPackage = null;
                        currentFilteredPackages.forEach(currentPackage => {
                            if (
                                tempMinPackage == null ||
                                parseFloat(currentPackage.lensPackage.listPrice) <
                                    parseFloat(tempMinPackage.lensPackage.listPrice)
                            ) {
                                tempMinPackage = currentPackage;
                            }
                        });
                        treatmentPackage1 = tempMinPackage;
                    }
                }

                if (isInsuranceEnabled) {
                    priceObject =
                        treatmentPackage2 !== null &&
                        treatmentPackage1.lensPackage.insPrice !== null
                            ? {
                                  delta:
                                      parseFloat(treatmentPackage1.lensPackage.insPrice) -
                                      parseFloat(treatmentPackage2.lensPackage.insPrice),
                                  framePrice: parseFloat(treatmentPackage1.frame.insPrice),
                                  lensPrice: parseFloat(treatmentPackage1.lensPackage.insPrice),
                              }
                            : null;
                } else {
                    priceObject =
                        treatmentPackage2 !== null
                            ? {
                                  delta:
                                      parseFloat(treatmentPackage1.lensPackage.offerPrice) -
                                      parseFloat(treatmentPackage2.lensPackage.offerPrice),
                                  framePrice: parseFloat(treatmentPackage1.frame.offerPrice),
                                  lensPrice: parseFloat(treatmentPackage1.lensPackage.offerPrice),
                              }
                            : null;
                }
            }
        }

        return priceObject;
    };

    const handleToggleTreatmentOption = treatmentOption => {
        // If only one treatment option is passed
        if (treatmentOption && Object.entries(treatmentOption).length == 1) {
            let tempTreatmentOptions = utils.deepCopy(treatmentOptions);
            let tempTreatmentOptionsPackages = utils.deepCopy(treatmentOptionsPackages);

            const treatmentOptionKey = Object.keys(treatmentOption)[0];
            const treatmentOptionValue = Object.values(treatmentOption)[0];

            if (tempTreatmentOptions == null) {
                tempTreatmentOptions = {};
                tempTreatmentOptionsPackages = {};
            }

            // If treatmentOption has already been selected
            if (
                tempTreatmentOptions[treatmentOptionKey] !== null &&
                tempTreatmentOptions[treatmentOptionKey] !== undefined
            ) {
                // Toggle treatmentOption off if value is the same
                if (treatmentOptionValue == null) {
                    delete tempTreatmentOptions[treatmentOptionKey];
                    delete tempTreatmentOptionsPackages[treatmentOptionKey];

                    if (isBlueLightOnly && treatmentOptionKey == 'blueLight') {
                        setIsBlueLightOnly(false);
                    }
                } else {
                    // Overwrite treatmentOption if value is not the same

                    if (!isLearnMoreModalOpen) {
                        tempTreatmentOptions[treatmentOptionKey] = treatmentOptionValue;
                    }

                    if (
                        !isBlueLightOnly &&
                        treatmentOptionKey == 'blueLight' &&
                        tempTreatmentOptions['transition'] == null
                    ) {
                        setIsBlueLightOnly(true);
                    }
                }

                if (Object.entries(tempTreatmentOptions).length == 0) {
                    tempTreatmentOptions = null;
                    tempTreatmentOptionsPackages = null;
                } else {
                    let minTreatmentOptionPackage = getMinTreatmentOptionPackage(
                        treatmentOptionKey,
                        treatmentOptionValue
                    );

                    if (minTreatmentOptionPackage) {
                        tempTreatmentOptionsPackages = {
                            ...tempTreatmentOptionsPackages,
                            [treatmentOptionKey]: minTreatmentOptionPackage,
                        };
                    }
                }
            } else {
                // If treatmentOption has not been selected
                if (!isLearnMoreModalOpen) {
                    tempTreatmentOptions[treatmentOptionKey] = treatmentOptionValue;
                }

                if (
                    !isBlueLightOnly &&
                    treatmentOptionKey == 'blueLight' &&
                    tempTreatmentOptions['transition'] == null
                ) {
                    setIsBlueLightOnly(true);
                } else if (
                    isBlueLightOnly &&
                    treatmentOptionKey == 'blueLight' &&
                    treatmentOptionValue == null
                ) {
                    setIsBlueLightOnly(false);
                }

                let minTreatmentOptionPackage = getMinTreatmentOptionPackage(
                    treatmentOptionKey,
                    treatmentOptionValue
                );

                if (minTreatmentOptionPackage) {
                    tempTreatmentOptionsPackages = {
                        ...tempTreatmentOptionsPackages,
                        [treatmentOptionKey]: minTreatmentOptionPackage,
                    };
                }
            }

            if (!isLearnMoreModalOpen) {
                dispatch(setTreatmentOptions(tempTreatmentOptions));
                dispatch(setTreatmentOptionsPackages(tempTreatmentOptionsPackages));
            }

            // Set current selected package
            const currentFilteredPackages = data.packages.filter(currentPackage => {
                if (
                    selectedOptions &&
                    selectedOptions.type &&
                    currentPackage.lensPackage.type == selectedOptions.type &&
                    selectedOptions.brand &&
                    currentPackage.lensPackage.brand == selectedOptions.brand &&
                    selectedOptions.thickness &&
                    currentPackage.lensPackage.thickness == selectedOptions.thickness &&
                    utils.hasValidPrescription(currentPackage, selectedPrescriptionObject) &&
                    (!tempTreatmentOptions ||
                        !tempTreatmentOptions.polar ||
                        tempTreatmentOptions.polar == currentPackage.lensPackage.polar) &&
                    (!tempTreatmentOptions ||
                        !tempTreatmentOptions.antiReflective ||
                        tempTreatmentOptions.antiReflective ==
                            currentPackage.lensPackage.antiReflective) &&
                    (!tempTreatmentOptions ||
                        !tempTreatmentOptions.blueLight ||
                        tempTreatmentOptions.blueLight == currentPackage.lensPackage.blueLight) &&
                    (!tempTreatmentOptions ||
                        !tempTreatmentOptions.transition ||
                        tempTreatmentOptions.transition == currentPackage.lensPackage.transition) &&
                    (!tempTreatmentOptions ||
                        !tempTreatmentOptions.treatment ||
                        tempTreatmentOptions.treatment == currentPackage.lensPackage.treatment) &&
                    (!tempTreatmentOptions ||
                        !tempTreatmentOptions.colorCategory ||
                        tempTreatmentOptions.colorCategory ==
                            currentPackage.lensPackage.colorCategory) &&
                    (!tempTreatmentOptions ||
                        !tempTreatmentOptions.color ||
                        tempTreatmentOptions.color == currentPackage.lensPackage.color)
                ) {
                    return currentPackage;
                }
            });

            let packageForPriceUpdate = baseLensPackage;

            if (currentFilteredPackages.length > 0) {
                packageForPriceUpdate = currentFilteredPackages.reduce(
                    (prevFilteredPackage, currentFilteredPackage) => {
                        return parseFloat(currentFilteredPackage.lensPackage.listPrice) <
                            parseFloat(prevFilteredPackage.lensPackage.listPrice)
                            ? currentFilteredPackage
                            : prevFilteredPackage;
                    },
                    currentFilteredPackages[0]
                );
            }

            setCurrentLensPackage(packageForPriceUpdate);

            let result = {
                key: treatmentOptionKey,
                value: treatmentOptionValue,
            };

            if (treatmentOptionValue !== null) {
                result.key = constants.stepsOptionsMap.treatments.indexOf(treatmentOptionKey) + 1;
            } else {
                result.key = constants.stepsOptionsMap.treatments.indexOf(treatmentOptionKey);
            }

            dispatch(setGoToTreatment(result));

            if (
                treatmentOptionKey === 'blueLight' &&
                !isLearnMoreModalOpen &&
                currentFilteredPackages[0] &&
                currentFilteredPackages[0].lensPackage &&
                currentFilteredPackages[0].lensPackage.transition === null &&
                currentFilteredPackages[0].lensPackage.color !== null
            ) {
                dispatch(setIsLensGaming(isLensGaming ? false : true));
            } else {
                dispatch(setIsLensGaming(false));
            }
        }
    };

    useEffect(() => {
        if (constants.stepsOptionsMap.treatments[currentTreatment]) {
            const treatmentElem = document.getElementById(
                isMobile && constants.stepsOptionsMap.treatments[currentTreatment] === 'color'
                    ? constants.stepsOptionsMap.treatments[currentTreatment] + '-mobile'
                    : constants.stepsOptionsMap.treatments[currentTreatment]
            );
            let name =
                isMobile && constants.stepsOptionsMap.treatments[currentTreatment] === 'color'
                    ? constants.stepsOptionsMap.treatments[currentTreatment] + '-mobile'
                    : constants.stepsOptionsMap.treatments[currentTreatment];

            if (treatmentElem) {
                if (isMobile) {
                    scroller.scrollTo(name, {
                        duration: 2500,
                        smooth: true,
                        containerId: 'main-content',
                    });
                } else {
                    scroller.scrollTo(name, {
                        duration: 2500,
                        smooth: true,
                        containerId: 'scroll-view-steps',
                    });
                }
            }
        }
    }, [currentTreatment, currentTreatmentSelected]);

    const handleNoTreatments = () => {
        if (
            baseLensPackage !== null &&
            (baseLensPackage.lensPackage.polar !== null ||
                baseLensPackage.lensPackage.antiReflective !== null ||
                baseLensPackage.lensPackage.blueLight !== null ||
                baseLensPackage.lensPackage.transition !== null ||
                baseLensPackage.lensPackage.colorCategory !== null ||
                baseLensPackage.lensPackage.color !== null)
        ) {
            let includedOption = {};

            if (baseLensPackage.lensPackage.polar !== null) {
                includedOption['polar'] = baseLensPackage.lensPackage.polar;
            }
            if (baseLensPackage.lensPackage.antiReflective !== null) {
                includedOption['antiReflective'] = baseLensPackage.lensPackage.antiReflective;
            }
            if (baseLensPackage.lensPackage.blueLight !== null) {
                includedOption['blueLight'] = baseLensPackage.lensPackage.blueLight;
            }
            if (baseLensPackage.lensPackage.transition !== null) {
                includedOption['transition'] = baseLensPackage.lensPackage.transition;
            }
            if (baseLensPackage.lensPackage.colorCategory !== null) {
                includedOption['colorCategory'] = baseLensPackage.lensPackage.colorCategory;
            }
            if (baseLensPackage.lensPackage.color !== null) {
                includedOption['color'] = baseLensPackage.lensPackage.color;
            }

            dispatch(setSelectedOptions(includedOption));
        } else {
            dispatch(
                setSelectedOptions({
                    noTreatments: true,
                })
            );
        }

        if (editColorLens) dispatch(setEditColorLens(false));
        if (isLensGaming) dispatch(setIsLensGaming(false));
        if (productImageOld) {
            dispatch(setProductImage(productImageOld));
            dispatch(setProductImageOld(null));
            dispatch(setImageErrorMessage(false));
            dispatch(setLensErrorMessage(false));
        }
    };

    useEffect(() => {
        if (!isLearnMoreModalOpen) {
            dispatch(setTreatmentOptions(null));
            dispatch(setTreatmentOptionsPackages(null));
        }
    }, []);

    useEffect(() => {
        if (baseLensPackage) {
            setCurrentLensPackage(baseLensPackage);
        }
    }, [baseLensPackage]);

    const renderDefaultOptions = () => {
        let extraTreatment = null;

        if (
            currentLensPackage !== null &&
            currentLensPackage.lensPackage.antiScratch &&
            currentLensPackage.lensPackage.uvProtection
        ) {
            extraTreatment = 'uvProtection';
            dispatch(setExtraTreatment(extraTreatment));
        } else if (
            currentLensPackage !== null &&
            currentLensPackage.lensPackage.antiScratch &&
            !currentLensPackage.lensPackage.uvProtection
        ) {
            extraTreatment = 'antiScratch';
            dispatch(setExtraTreatment(extraTreatment));
        }

        return (
            extraTreatment !== null && (
                <div className="step-radio-group additional-treatment">
                    <StepRadioButton
                        id={extraTreatment}
                        title={labels.steps.treatments.extraTreatments[extraTreatment].title}
                        description={labels.steps.treatments.extraTreatments[extraTreatment].title}
                        imageFileName={
                            props.config.data.frame.category &&
                            props.config.data.frame.category == 'EYEGLASSES'
                                ? labels.steps.treatments.extraTreatments[extraTreatment]
                                      .imageFileName
                                : labels.steps.treatments.extraTreatments[extraTreatment]
                                      .imageFileNameSun
                        }
                        imageAlt={labels.steps.treatments.extraTreatments[extraTreatment].title}
                        type={props.type ? props.type : 'treatment'}
                        isSelected={false}
                        isDisabled={true}
                        isIncluded={true}
                        isLearnMore={false}
                    />
                </div>
            )
        );
    };

    useEffect(() => {
        if (
            isInsuranceEnabled &&
            treatmentOptions !== null &&
            treatmentOptionsPackages !== null &&
            currentLensPackage !== null &&
            currentStep == constants.steps.indexOf('treatments')
        ) {
            let insurancePackages = [];

            if (
                currentLensPackage.lensPackage.insurable == true &&
                currentLensPackage.lensPackage.insPrice == null
            ) {
                insurancePackages.push(currentLensPackage);
            }

            const treatmentPackages = Object.values(treatmentOptionsPackages).filter(
                currentPackage => {
                    if (
                        currentPackage.lensPackage.insurable == true &&
                        currentPackage.lensPackage.insPrice == null
                    ) {
                        return currentPackage;
                    }
                }
            );

            if (treatmentPackages.length > 0) {
                const minTreatmentPackage = treatmentPackages.reduce(
                    (prevPackage, filteredPackage) => {
                        return parseFloat(filteredPackage.lensPackage.listPrice) <
                            parseFloat(prevPackage.lensPackage.listPrice)
                            ? filteredPackage
                            : prevPackage;
                    },
                    treatmentPackages[0]
                );

                if (minTreatmentPackage !== null) {
                    if (
                        minTreatmentPackage.lensPackage.upc !== currentLensPackage.lensPackage.upc
                    ) {
                        insurancePackages.push(minTreatmentPackage);
                    }
                }
            }

            props.handleGetInsurancePrice(insurancePackages);
        }
    }, [treatmentOptions]);

    useEffect(() => {
        // Update color treatment
        if (treatmentOptions) {
            handleToggleTreatmentOption(
                {
                    color: selectedColorOption !== null ? selectedColorOption.id : null,
                },
                selectedColorOption !== null ? selectedColorOption.package : null
            );
        }

        if (
            props.config.data.frame.category &&
            props.config.data.frame.category.toUpperCase() === 'SUNGLASSES' &&
            selectedColorOption &&
            !isLearnMoreModalOpen &&
            treatmentOptions
        ) {
            let url = constants.imageFrameLayer
                .replace('##MODEL##', props.config.data.frame.model)
                .replace('##COLOR##', props.config.data.frame.color);

            const selectedColorPackages = data.packages.filter(currentPackage => {
                if (
                    selectedOptions &&
                    selectedOptions.type &&
                    currentPackage.lensPackage.type == selectedOptions.type &&
                    selectedOptions.brand &&
                    currentPackage.lensPackage.brand == selectedOptions.brand &&
                    selectedOptions.thickness &&
                    currentPackage.lensPackage.thickness == selectedOptions.thickness &&
                    utils.hasValidPrescription(currentPackage, selectedPrescriptionObject) &&
                    (!treatmentOptions ||
                        (treatmentOptions &&
                            (!treatmentOptions.polar ||
                                (treatmentOptions.polar &&
                                    currentPackage.lensPackage.polar == treatmentOptions.polar)) &&
                            (!treatmentOptions.antiReflective ||
                                (treatmentOptions.antiReflective &&
                                    currentPackage.lensPackage.antiReflective ==
                                        treatmentOptions.antiReflective)) &&
                            (!treatmentOptions.blueLight ||
                                (treatmentOptions.blueLight &&
                                    currentPackage.lensPackage.blueLight ==
                                        treatmentOptions.blueLight)) &&
                            (!treatmentOptions.transition ||
                                (treatmentOptions.transition &&
                                    currentPackage.lensPackage.transition ==
                                        treatmentOptions.transition)) &&
                            (!treatmentOptions.colorCategory ||
                                (treatmentOptions.colorCategory &&
                                    currentPackage.lensPackage.colorCategory ==
                                        treatmentOptions.colorCategory)) &&
                            (!treatmentOptions.treatment ||
                                (treatmentOptions.treatment &&
                                    currentPackage.lensPackage.treatment ==
                                        treatmentOptions.treatment)))) &&
                    currentPackage.lensPackage.color &&
                    currentPackage.lensPackage.color == selectedColorOption.id &&
                    currentPackage.lensPackage.clen
                ) {
                    return currentPackage;
                }
            });

            if (selectedColorPackages.length > 0) {
                const selectedColorPackage = selectedColorPackages[0];

                dispatch(setImageErrorMessage(false));
                dispatch(setLensErrorMessage(false));
                let urlLensesImage = constants.imageLens
                    .replace('##MODEL##', props.config.data.frame.model)
                    .replace('##CLEN##', selectedColorPackage.lensPackage.clen);

                if (sourceColor) sourceColor.cancel();

                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                setSourceColor(source);

                axios
                    .get(urlLensesImage, {
                        cancelToken: source.token,
                    })
                    .then(() => {
                        if (brandSelected) {
                            //Se ho logo e lente
                            let brandName = brandSelected;
                            if (selectedColorPackage.lensPackage.polar && brandName === 'Ray-Ban')
                                brandName += '_P';
                            //else if() CHROMANCE

                            let urlLogoImage = constants.imageLogo
                                .replace('##MODEL##', props.config.data.frame.model)
                                .replace('##LOGO##', constants.logoMap[brandName]);

                            axios
                                .get(urlLogoImage, {
                                    cancelToken: source.token,
                                })
                                .then(() => {
                                    let compositionLens = constants.imageLensLogoLayer
                                        .replace('##MODEL##', props.config.data.frame.model)
                                        .replace('##CLEN##', selectedColorPackage.lensPackage.clen);
                                    url += compositionLens;
                                    let compositionLogo = constants.imageLogoLayer
                                        .replace('##MODEL##', props.config.data.frame.model)
                                        .replace('##LOGO##', constants.logoMap[brandName]);
                                    url += compositionLogo;
                                    axios
                                        .get(url, {
                                            cancelToken: source.token,
                                        })
                                        .then(() => {
                                            dispatch(setProductImage(url));
                                        })
                                        .catch(() => {
                                            fallbackImage(
                                                selectedColorPackage.lensPackage.clen,
                                                source
                                            );
                                        });
                                })
                                .catch(() => {
                                    fallbackImage(selectedColorPackage.lensPackage.clen, source);
                                });
                        } else {
                            //se ho solo lente e no logo
                            let compositionLens = constants.imageLensNoLogoLayer
                                .replace('##MODEL##', props.config.data.frame.model)
                                .replace('##CLEN##', selectedColorPackage.lensPackage.clen);
                            url += compositionLens;
                            axios
                                .get(url, {
                                    cancelToken: source.token,
                                })
                                .then(() => {
                                    dispatch(setProductImage(url));
                                })
                                .catch(() => {
                                    fallbackImage(selectedColorPackage.lensPackage.clen, source);
                                });
                        }
                    })
                    .catch(() => {
                        fallbackImage(selectedColorPackage.lensPackage.clen, source);
                    });
            }
        }
    }, [selectedColorOption]);

    const fallbackImage = (clen, source) => {
        let lensPreview = constants.imageLensPreview.replace('##CLEN##', clen);
        axios
            .get(lensPreview, {
                cancelToken: source.token,
            })
            .then(() => {
                dispatch(setProductImage(lensPreview));
                dispatch(setLensErrorMessage(true));
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    if (productImageOld) dispatch(setProductImage(productImageOld));
                    dispatch(setImageErrorMessage(true));
                }
            });
    };

    const getColorOptionsLearnMore = (packages, polarValue, visibleCategories) => {
        let visibleColors = {};
        packages
            .filter(currentPackage => {
                if (
                    currentPackage.lensPackage.color &&
                    currentPackage.lensPackage.polar == polarValue &&
                    visibleCategories.indexOf(currentPackage.lensPackage.colorCategory) !== -1
                ) {
                    return currentPackage;
                }
            })
            .forEach(currentPackage => {
                // Filter out duplicates
                const currentColor = currentPackage.lensPackage.color;
                const currentColorContent = data.content.color[currentColor];
                const currentColorCategory = currentPackage.lensPackage.colorCategory;
                if (
                    currentColorContent &&
                    currentColorCategory &&
                    !visibleColors[currentColorCategory]
                ) {
                    visibleColors[currentColorCategory] = {};
                }
                if (
                    currentColorContent &&
                    currentColorCategory &&
                    !visibleColors[currentColorCategory][currentColor]
                ) {
                    visibleColors[currentColorCategory][currentColor] =
                        data.content.color[currentColor];
                }
            });

        return visibleColors;
    };

    const getColorOptions = (packages, treatmentKey, treatmentValue) => {
        let visibleColors = {};

        packages
            .filter(currentPackage => {
                const treatmentKeyValue = currentPackage.lensPackage[treatmentKey];

                if (currentPackage.lensPackage.color && treatmentKeyValue == treatmentValue) {
                    return currentPackage;
                }
            })
            .forEach(currentPackage => {
                // Filter out duplicates
                const currentColor = currentPackage.lensPackage.color;
                const currentColorContent = data.content.color[currentColor];

                if (
                    currentColorContent &&
                    (!visibleColors[currentColor] ||
                        (visibleColors[currentColor] &&
                            parseFloat(visibleColors[currentColor].lensPackage.listPrice) >
                                parseFloat(currentPackage.lensPackage.listPrice)))
                ) {
                    visibleColors[currentColor] = currentPackage;
                }
            });

        return Object.values(visibleColors)
            .map(colorPackage => {
                const currentColor = colorPackage.lensPackage.color;
                const currentColorContent = data.content.color[currentColor];

                return {
                    id: currentColor,
                    title: currentColorContent.title,
                    imageFileName1: currentColorContent.imageFileName1,
                    imageFileName2: currentColorContent.imageFileName2,
                    package: colorPackage,
                    sequence: currentColorContent.sequence,
                };
            })
            .sort(utils.sortBySequence);
    };

    const renderContent = () => {
        const treatmentPackages = data.packages.filter(currentPackage => {
            if (
                selectedOptions &&
                selectedOptions.type &&
                currentPackage.lensPackage.type == selectedOptions.type &&
                selectedOptions.brand &&
                currentPackage.lensPackage.brand == selectedOptions.brand &&
                selectedOptions.thickness &&
                currentPackage.lensPackage.thickness == selectedOptions.thickness &&
                utils.hasValidPrescription(currentPackage, selectedPrescriptionObject)
            ) {
                return currentPackage;
            }
        });

        // Get all treatment packages which have the current treatment options set
        let treatmentIncludedPackages = utils.deepCopy(treatmentPackages);

        if (treatmentOptions) {
            Object.entries(treatmentOptions).forEach(treatmentOption => {
                const treatmentOptionKey = treatmentOption[0];
                const treatmentOptionValue = treatmentOption[1];

                treatmentIncludedPackages = treatmentIncludedPackages.filter(
                    treatmentIncludedPackage => {
                        if (
                            treatmentIncludedPackage.lensPackage[treatmentOptionKey] ==
                            treatmentOptionValue
                        ) {
                            return treatmentIncludedPackage;
                        }
                    }
                );
            });
        }

        // Polarized
        const polarPackages = treatmentPackages.filter(treatmentPackage => {
            if (isGVP && treatmentPackage.frame.promoType === constants.promoTypes.GVP) {
                if (
                    treatmentPackage.lensPackage.treatment &&
                    treatmentPackage.lensPackage.treatmentGroup === 'polar' &&
                    utils.hasValidPrescription(treatmentPackage, selectedPrescriptionObject)
                ) {
                    return treatmentPackage;
                }
            } else if (
                !isGVP &&
                treatmentPackage.lensPackage.polar &&
                (!treatmentOptions ||
                    (treatmentOptions &&
                        (!treatmentOptions.antiReflective ||
                            treatmentPackage.lensPackage.antiReflective ==
                                treatmentOptions.antiReflective) &&
                        (!treatmentOptions.blueLight ||
                            treatmentPackage.lensPackage.blueLight == treatmentOptions.blueLight) &&
                        (!treatmentOptions.transition ||
                            treatmentPackage.lensPackage.transition ==
                                treatmentOptions.transition) &&
                        (!treatmentOptions.colorCategory ||
                            treatmentPackage.lensPackage.colorCategory ==
                                treatmentOptions.colorCategory) &&
                        (!treatmentOptions.color ||
                            treatmentPackage.lensPackage.color == treatmentOptions.color))) &&
                utils.hasValidPrescription(treatmentPackage, selectedPrescriptionObject)
            ) {
                return treatmentPackage;
            } else {
                return null;
            }
        });

        let visiblePolar = {};

        polarPackages.forEach(polarPackage => {
            // Filter out duplicates
            const isGVPPackage = isGVP && polarPackage.frame.promoType === constants.promoTypes.GVP;
            const currentPolar = isGVPPackage
                ? polarPackage.lensPackage.treatment
                : polarPackage.lensPackage.polar;
            const currentPolarContent = isGVPPackage
                ? data.content.treatment[currentPolar]
                : data.content.polar[currentPolar];
            if (
                currentPolarContent &&
                (!visiblePolar[currentPolar] ||
                    (visiblePolar[currentPolar] &&
                        parseFloat(visiblePolar[currentPolar].lensPackage.listPrice) >
                            parseFloat(polarPackage.lensPackage.listPrice)))
            ) {
                visiblePolar[currentPolar] = polarPackage;
            }
        });

        const polarOptions = Object.values(visiblePolar)
            .map(polarPackage => {
                const isGVPPackage =
                    isGVP && polarPackage.frame.promoType === constants.promoTypes.GVP;
                const currentPolar = isGVPPackage
                    ? polarPackage.lensPackage.treatment
                    : polarPackage.lensPackage.polar;
                const currentPolarContent = isGVPPackage
                    ? data.content.treatment[currentPolar]
                    : data.content.polar[currentPolar];
                const treatmentKey = isGVPPackage ? 'treatment' : 'polar';

                let isIncludedCheck = false;
                let baseLensIsIncludedCheck = false;
                let currentPolarColorOptions = null;

                if (!isGVPPackage) {
                    isIncludedCheck = checkTreatmentIncluded(
                        treatmentIncludedPackages,
                        'polar',
                        currentPolar
                    );

                    baseLensIsIncludedCheck =
                        baseLensPackage !== null &&
                        baseLensPackage.lensPackage.polar == currentPolar;
                } else {
                    currentPolarColorOptions = getColorOptions(
                        polarPackages,
                        treatmentKey,
                        currentPolar
                    );
                }

                const priceObject = getPriceObject(
                    polarPackage,
                    treatmentKey,
                    currentPolar,
                    isInsuranceEnabled
                );

                return {
                    key: treatmentKey,
                    id: currentPolar,
                    title: currentPolarContent.title,
                    imageFileName: currentPolarContent.imageFileName,
                    imageAlt: currentPolarContent.title,
                    description: currentPolarContent.description,
                    sequence: currentPolarContent.sequence,
                    colorOptions: currentPolarColorOptions,
                    package: polarPackage,
                    price:
                        !baseLensIsIncludedCheck && priceObject
                            ? isGVPPackage && !isInsuranceEnabled
                                ? priceObject.framePrice + priceObject.lensPrice
                                : isGVPPackage
                                ? priceObject.lensPrice
                                : priceObject.delta
                            : null,
                    discount: null,
                    included:
                        baseLensIsIncludedCheck ||
                        ((!treatmentOptions ||
                            (treatmentOptions &&
                                (!treatmentOptions.polar ||
                                    (treatmentOptions.color &&
                                        treatmentOptionsPackages['color'] &&
                                        treatmentOptionsPackages['color'].lensPackage.polar ==
                                            currentPolar)))) &&
                            isIncludedCheck),
                    disabled:
                        baseLensIsIncludedCheck ||
                        ((!treatmentOptions ||
                            (treatmentOptions &&
                                (!treatmentOptions.polar ||
                                    (treatmentOptions.color &&
                                        treatmentOptionsPackages['color'] &&
                                        treatmentOptionsPackages['color'].lensPackage.polar ==
                                            currentPolar)))) &&
                            isIncludedCheck),
                    alreadyIncluded:
                        baseLensIsIncludedCheck ||
                        ((!treatmentOptions ||
                            (treatmentOptions &&
                                (!treatmentOptions.polar ||
                                    (treatmentOptions.color &&
                                        treatmentOptionsPackages['color'] &&
                                        treatmentOptionsPackages['color'].lensPackage.polar ==
                                            currentPolar)))) &&
                            isIncludedCheck),
                };
            })
            .sort(utils.sortBySequence);

        // Anti-reflective
        const arPackages = treatmentPackages.filter(treatmentPackage => {
            if (isGVP && treatmentPackage.frame.promoType === constants.promoTypes.GVP) {
                if (
                    treatmentPackage.lensPackage.treatment &&
                    treatmentPackage.lensPackage.treatmentGroup === 'antiReflective' &&
                    utils.hasValidPrescription(treatmentPackage, selectedPrescriptionObject)
                ) {
                    return treatmentPackage;
                }
            } else if (
                !isGVP &&
                treatmentPackage.lensPackage.antiReflective &&
                (!treatmentOptions ||
                    (treatmentOptions &&
                        (!treatmentOptions.polar ||
                            treatmentPackage.lensPackage.polar == treatmentOptions.polar) &&
                        (!treatmentOptions.blueLight ||
                            treatmentPackage.lensPackage.blueLight == treatmentOptions.blueLight) &&
                        (!treatmentOptions.transition ||
                            treatmentPackage.lensPackage.transition ==
                                treatmentOptions.transition) &&
                        (!treatmentOptions.colorCategory ||
                            treatmentPackage.lensPackage.colorCategory ==
                                treatmentOptions.colorCategory) &&
                        (!treatmentOptions.color ||
                            treatmentPackage.lensPackage.color == treatmentOptions.color))) &&
                utils.hasValidPrescription(treatmentPackage, selectedPrescriptionObject)
            ) {
                return treatmentPackage;
            } else {
                return null;
            }
        });

        let visibleAR = {};

        arPackages.forEach(arPackage => {
            // Filter out duplicates
            const isGVPPackage = isGVP && arPackage.frame.promoType === constants.promoTypes.GVP;
            const currentAR = isGVPPackage
                ? arPackage.lensPackage.treatment
                : arPackage.lensPackage.antiReflective;
            const currentARContent = isGVPPackage
                ? data.content.treatment[currentAR]
                : data.content.antiReflective[currentAR];

            if (
                currentARContent &&
                (!visibleAR[currentAR] ||
                    (visibleAR[currentAR] &&
                        parseFloat(visibleAR[currentAR].lensPackage.listPrice) >
                            parseFloat(arPackage.lensPackage.listPrice)))
            ) {
                visibleAR[currentAR] = arPackage;
            }
        });

        const arOptions = Object.values(visibleAR)
            .map(arPackage => {
                const isGVPPackage =
                    isGVP && arPackage.frame.promoType === constants.promoTypes.GVP;
                const currentAR = isGVPPackage
                    ? arPackage.lensPackage.treatment
                    : arPackage.lensPackage.antiReflective;
                const currentARContent = isGVPPackage
                    ? data.content.treatment[currentAR]
                    : data.content.antiReflective[currentAR];
                const treatmentKey = isGVPPackage ? 'treatment' : 'antiReflective';

                let isIncludedCheck = false;
                let baseLensIsIncludedCheck = false;
                let currentARColorOptions = null;

                if (!isGVPPackage) {
                    isIncludedCheck = checkTreatmentIncluded(
                        treatmentIncludedPackages,
                        'antiReflective',
                        currentAR
                    );

                    baseLensIsIncludedCheck =
                        baseLensPackage !== null &&
                        baseLensPackage.lensPackage.antiReflective == currentAR;
                } else {
                    currentARColorOptions = getColorOptions(arPackages, treatmentKey, currentAR);
                }

                const priceObject = getPriceObject(
                    arPackage,
                    treatmentKey,
                    currentAR,
                    isInsuranceEnabled
                );

                return {
                    key: treatmentKey,
                    id: currentAR,
                    title: currentARContent.title,
                    imageFileName: currentARContent.imageFileName,
                    imageAlt: currentARContent.title,
                    description: currentARContent.description,
                    sequence: currentARContent.sequence,
                    colorOptions: currentARColorOptions,
                    package: arPackage,
                    price:
                        !baseLensIsIncludedCheck && priceObject
                            ? isGVPPackage && !isInsuranceEnabled
                                ? priceObject.framePrice + priceObject.lensPrice
                                : isGVPPackage
                                ? priceObject.lensPrice
                                : priceObject.delta
                            : null,
                    included:
                        baseLensIsIncludedCheck ||
                        ((!treatmentOptions ||
                            (treatmentOptions && !treatmentOptions.antiReflective)) &&
                            isIncludedCheck),
                    disabled:
                        baseLensIsIncludedCheck ||
                        ((!treatmentOptions ||
                            (treatmentOptions && !treatmentOptions.antiReflective)) &&
                            isIncludedCheck),
                    alreadyIncluded:
                        baseLensIsIncludedCheck ||
                        ((!treatmentOptions ||
                            (treatmentOptions && !treatmentOptions.antiReflective)) &&
                            isIncludedCheck),
                };
            })
            .sort(utils.sortBySequence);

        // Blue light
        const blueLightPackages = treatmentPackages.filter(treatmentPackage => {
            if (isGVP && treatmentPackage.frame.promoType === constants.promoTypes.GVP) {
                if (
                    treatmentPackage.lensPackage.treatment &&
                    treatmentPackage.lensPackage.treatmentGroup === 'blueLight' &&
                    utils.hasValidPrescription(treatmentPackage, selectedPrescriptionObject)
                ) {
                    return treatmentPackage;
                }
            } else if (
                !isGVP &&
                treatmentPackage.lensPackage.blueLight &&
                (!treatmentOptions ||
                    (treatmentOptions &&
                        (!treatmentOptions.polar ||
                            treatmentPackage.lensPackage.polar == treatmentOptions.polar) &&
                        (!treatmentOptions.antiReflective ||
                            treatmentPackage.lensPackage.antiReflective ==
                                treatmentOptions.antiReflective) &&
                        (!treatmentOptions.transition ||
                            treatmentPackage.lensPackage.transition ==
                                treatmentOptions.transition) &&
                        (!treatmentOptions.colorCategory ||
                            treatmentPackage.lensPackage.colorCategory ==
                                treatmentOptions.colorCategory) &&
                        (!treatmentOptions.color ||
                            treatmentPackage.lensPackage.color == treatmentOptions.color))) &&
                utils.hasValidPrescription(treatmentPackage, selectedPrescriptionObject)
            ) {
                return treatmentPackage;
            } else {
                return null;
            }
        });

        let visibleBlueLight = {};

        blueLightPackages.forEach(blueLightPackage => {
            // Filter out duplicates
            const isGVPPackage =
                isGVP && blueLightPackage.frame.promoType === constants.promoTypes.GVP;
            const currentBlueLight = isGVPPackage
                ? blueLightPackage.lensPackage.treatment
                : blueLightPackage.lensPackage.blueLight;
            const currentBlueLightContent = isGVPPackage
                ? data.content.treatment[currentBlueLight]
                : data.content.blueLight[currentBlueLight];

            if (
                currentBlueLightContent &&
                (!visibleBlueLight[currentBlueLight] ||
                    (visibleBlueLight[currentBlueLight] &&
                        parseFloat(visibleBlueLight[currentBlueLight].lensPackage.listPrice) >
                            parseFloat(blueLightPackage.lensPackage.listPrice)))
            ) {
                visibleBlueLight[currentBlueLight] = blueLightPackage;
            }
        });

        const blueLightOptions = Object.values(visibleBlueLight)
            .map(blueLightPackage => {
                const isGVPPackage =
                    isGVP && blueLightPackage.frame.promoType === constants.promoTypes.GVP;
                const currentBlueLight = isGVPPackage
                    ? blueLightPackage.lensPackage.treatment
                    : blueLightPackage.lensPackage.blueLight;
                const currentBlueLightContent = isGVPPackage
                    ? data.content.treatment[currentBlueLight]
                    : data.content.blueLight[currentBlueLight];
                const treatmentKey = isGVPPackage ? 'treatment' : 'blueLight';

                let isIncludedCheck = false;
                let baseLensIsIncludedCheck = false;
                let currentBlueLightColorOptions = null;

                if (!isGVPPackage) {
                    isIncludedCheck = checkTreatmentIncluded(
                        treatmentIncludedPackages,
                        'blueLight',
                        currentBlueLight
                    );

                    baseLensIsIncludedCheck =
                        baseLensPackage !== null &&
                        baseLensPackage.lensPackage.blueLight == currentBlueLight;
                } else {
                    currentBlueLightColorOptions = getColorOptions(
                        blueLightPackages,
                        treatmentKey,
                        currentBlueLight
                    );
                }

                const priceObject = getPriceObject(
                    blueLightPackage,
                    treatmentKey,
                    currentBlueLight,
                    isInsuranceEnabled
                );

                return {
                    key: treatmentKey,
                    id: currentBlueLight,
                    title: currentBlueLightContent.title,
                    imageFileName: currentBlueLightContent.imageFileName,
                    imageAlt: currentBlueLightContent.title,
                    description: currentBlueLightContent.description,
                    sequence: currentBlueLightContent.sequence,
                    colorOptions: currentBlueLightColorOptions,
                    package: blueLightPackage,
                    price:
                        !baseLensIsIncludedCheck && priceObject
                            ? isGVPPackage && !isInsuranceEnabled
                                ? priceObject.framePrice + priceObject.lensPrice
                                : isGVPPackage
                                ? priceObject.lensPrice
                                : priceObject.delta
                            : null,
                    included:
                        baseLensIsIncludedCheck ||
                        ((!treatmentOptions ||
                            (treatmentOptions &&
                                (!treatmentOptions.blueLight ||
                                    (treatmentOptions.transition &&
                                        treatmentOptionsPackages['transition'] &&
                                        treatmentOptionsPackages['transition'].lensPackage
                                            .blueLight == currentBlueLight)))) &&
                            isIncludedCheck),
                    disabled:
                        baseLensIsIncludedCheck ||
                        ((!treatmentOptions ||
                            (treatmentOptions &&
                                (!treatmentOptions.blueLight ||
                                    (treatmentOptions.transition &&
                                        treatmentOptionsPackages['transition'] &&
                                        treatmentOptionsPackages['transition'].lensPackage
                                            .blueLight == currentBlueLight)))) &&
                            isIncludedCheck),
                    alreadyIncluded:
                        baseLensIsIncludedCheck ||
                        ((!treatmentOptions ||
                            (treatmentOptions &&
                                (!treatmentOptions.blueLight ||
                                    (treatmentOptions.transition &&
                                        treatmentOptionsPackages['transition'] &&
                                        treatmentOptionsPackages['transition'].lensPackage
                                            .blueLight == currentBlueLight)))) &&
                            isIncludedCheck),
                    isLensGaming:
                        blueLightPackage.lensPackage.color !== null &&
                        blueLightPackages[0].lensPackage.transition === null,
                };
            })
            .sort(utils.sortBySequence);

        if (
            blueLightOptions[0] &&
            blueLightOptions[0].included &&
            blueLightPackages[0] &&
            blueLightPackages[0].lensPackage &&
            blueLightPackages[0].lensPackage.transition === null &&
            blueLightPackages[0].lensPackage.color !== null &&
            treatmentOptions == null
        ) {
            dispatch(setIsLensGaming(true));
        }

        // Transition
        const transitionPackages = treatmentPackages.filter(treatmentPackage => {
            if (isGVP && treatmentPackage.frame.promoType === constants.promoTypes.GVP) {
                if (
                    treatmentPackage.lensPackage.treatment &&
                    treatmentPackage.lensPackage.treatmentGroup === 'transition' &&
                    utils.hasValidPrescription(treatmentPackage, selectedPrescriptionObject)
                ) {
                    return treatmentPackage;
                }
            } else if (
                !isGVP &&
                treatmentPackage.lensPackage.transition &&
                (!treatmentOptions ||
                    (treatmentOptions &&
                        (!treatmentOptions.polar ||
                            treatmentPackage.lensPackage.polar == treatmentOptions.polar) &&
                        (!treatmentOptions.antiReflective ||
                            treatmentPackage.lensPackage.antiReflective ==
                                treatmentOptions.antiReflective) &&
                        (!treatmentOptions.blueLight ||
                            treatmentPackage.lensPackage.blueLight == treatmentOptions.blueLight) &&
                        (!treatmentOptions.colorCategory ||
                            treatmentPackage.lensPackage.colorCategory ==
                                treatmentOptions.colorCategory))) &&
                utils.hasValidPrescription(treatmentPackage, selectedPrescriptionObject)
            ) {
                return treatmentPackage;
            } else {
                return null;
            }
        });

        let visibleTransitions = {};

        transitionPackages.forEach(transitionPackage => {
            // Filter out duplicates
            const isGVPPackage =
                isGVP && transitionPackage.frame.promoType === constants.promoTypes.GVP;
            const currentTransition = isGVPPackage
                ? transitionPackage.lensPackage.treatment
                : transitionPackage.lensPackage.transition;
            const currentTransitionContent = isGVPPackage
                ? data.content.treatment[currentTransition]
                : data.content.transition[currentTransition];

            if (
                currentTransitionContent &&
                (!visibleTransitions[currentTransition] ||
                    (visibleTransitions[currentTransition] &&
                        parseFloat(visibleTransitions[currentTransition].lensPackage.listPrice) >
                            parseFloat(transitionPackage.lensPackage.listPrice)))
            ) {
                visibleTransitions[currentTransition] = transitionPackage;
            }
        });

        const transitionOptions = Object.values(visibleTransitions)
            .map(transitionPackage => {
                const isGVPPackage =
                    isGVP && transitionPackage.frame.promoType === constants.promoTypes.GVP;
                const currentTransition = isGVPPackage
                    ? transitionPackage.lensPackage.treatment
                    : transitionPackage.lensPackage.transition;
                const currentTransitionContent = isGVPPackage
                    ? data.content.treatment[currentTransition]
                    : data.content.transition[currentTransition];
                const treatmentKey = isGVPPackage ? 'treatment' : 'transition';

                const currentTransitionColorOptions = getColorOptions(
                    transitionPackages,
                    treatmentKey,
                    currentTransition
                );

                const priceObject = getPriceObject(
                    transitionPackage,
                    treatmentKey,
                    currentTransition,
                    isInsuranceEnabled
                );

                return {
                    key: treatmentKey,
                    id: currentTransition,
                    title: currentTransitionContent.title,
                    imageFileName: currentTransitionContent.imageFileName,
                    imageAlt: currentTransitionContent.title,
                    description: currentTransitionContent.description,
                    isBlueLightIncluded: transitionPackage.lensPackage.blueLight ? true : false,
                    colorOptions: currentTransitionColorOptions,
                    package: transitionPackage,
                    sequence: currentTransitionContent.sequence,
                    price: priceObject
                        ? isGVPPackage && !isInsuranceEnabled
                            ? priceObject.framePrice + priceObject.lensPrice
                            : isGVPPackage
                            ? priceObject.lensPrice
                            : priceObject.delta
                        : null,
                };
            })
            .sort(utils.sortBySequence);

        // Color category
        const colorCategoryPackages = treatmentPackages.filter(treatmentPackage => {
            if (isGVP && treatmentPackage.frame.promoType === constants.promoTypes.GVP) {
                if (
                    treatmentPackage.lensPackage.treatment &&
                    treatmentPackage.lensPackage.treatmentGroup === 'colorCategory' &&
                    utils.hasValidPrescription(treatmentPackage, selectedPrescriptionObject)
                ) {
                    return treatmentPackage;
                }
            } else if (
                !isGVP &&
                treatmentPackage.lensPackage.colorCategory &&
                (!treatmentOptions ||
                    (treatmentOptions &&
                        (!treatmentOptions.polar ||
                            treatmentPackage.lensPackage.polar == treatmentOptions.polar) &&
                        (!treatmentOptions.antiReflective ||
                            treatmentPackage.lensPackage.antiReflective ==
                                treatmentOptions.antiReflective) &&
                        (!treatmentOptions.blueLight ||
                            treatmentPackage.lensPackage.blueLight == treatmentOptions.blueLight) &&
                        (!treatmentOptions.transition ||
                            treatmentPackage.lensPackage.transition ==
                                treatmentOptions.transition))) &&
                utils.hasValidPrescription(treatmentPackage, selectedPrescriptionObject)
            ) {
                return treatmentPackage;
            } else {
                return null;
            }
        });

        let visibleColorCategories = {};

        colorCategoryPackages.forEach(colorCategoryPackage => {
            // Filter out duplicates
            const isGVPPackage =
                isGVP && colorCategoryPackage.frame.promoType === constants.promoTypes.GVP;
            const currentColorCategory = isGVPPackage
                ? colorCategoryPackage.lensPackage.treatment
                : colorCategoryPackage.lensPackage.colorCategory;
            const currentColorCategoryContent = isGVPPackage
                ? data.content.treatment[currentColorCategory]
                : data.content.colorCategory[currentColorCategory];

            if (
                currentColorCategoryContent &&
                (!visibleColorCategories[currentColorCategory] ||
                    (visibleColorCategories[currentColorCategory] &&
                        parseFloat(
                            visibleColorCategories[currentColorCategory].lensPackage.listPrice
                        ) > parseFloat(colorCategoryPackage.lensPackage.listPrice)))
            ) {
                visibleColorCategories[currentColorCategory] = colorCategoryPackage;
            }
        });

        const visibleCategories = Object.values(visibleColorCategories).map(
            colorCategoryPackage => {
                return colorCategoryPackage.lensPackage.colorCategory;
            }
        );

        const colorCategoryOptions = Object.values(visibleColorCategories)
            .map(colorCategoryPackage => {
                const isGVPPackage =
                    isGVP && colorCategoryPackage.frame.promoType === constants.promoTypes.GVP;
                const currentColorCategory = isGVPPackage
                    ? colorCategoryPackage.lensPackage.treatment
                    : colorCategoryPackage.lensPackage.colorCategory;
                const currentPolar = colorCategoryPackage.lensPackage.polar;
                const currentColorCategoryContent = isGVPPackage
                    ? data.content.treatment[currentColorCategory]
                    : data.content.colorCategory[currentColorCategory];
                const treatmentKey = isGVPPackage ? 'treatment' : 'colorCategory';

                const currentColorCategoryColorOptions = getColorOptions(
                    colorCategoryPackages,
                    treatmentKey,
                    currentColorCategory
                );

                const currentColorCategoryLearnMore = getColorOptionsLearnMore(
                    colorCategoryPackages,
                    currentPolar,
                    visibleCategories
                );

                const priceObject = getPriceObject(
                    colorCategoryPackage,
                    treatmentKey,
                    currentColorCategory,
                    isInsuranceEnabled
                );

                return {
                    key: treatmentKey,
                    id: currentColorCategory,
                    title: currentColorCategoryContent.title,
                    imageFileName: currentColorCategoryContent.imageFileName,
                    imageAlt: currentColorCategoryContent.title,
                    description: currentColorCategoryContent.description,
                    colorOptions: currentColorCategoryColorOptions,
                    isMirror: colorCategoryPackage.lensPackage.isMirror,
                    package: colorCategoryPackage,
                    colorLearnMoreOptions: currentColorCategoryLearnMore,
                    visibleColorCategories: visibleCategories,
                    sequence: currentColorCategoryContent.sequence,
                    price: priceObject
                        ? isGVPPackage && !isInsuranceEnabled
                            ? priceObject.framePrice + priceObject.lensPrice
                            : isGVPPackage
                            ? priceObject.lensPrice
                            : priceObject.delta
                        : null,
                };
            })
            .sort(utils.sortBySequence);

        return (
            <>
                {!props.isLearnMore && (
                    <>
                        <a
                            href="#"
                            onClick={() => {
                                handleNoTreatments();
                            }}
                            className="noTreatments hidden"
                        >
                            {labels.steps.treatments.noTreatments}
                        </a>
                        {renderDefaultOptions()}
                    </>
                )}
                {polarOptions && (!props.isLearnMore || props.showOnly === 'polar') ? (
                    <SubStep
                        key="polar"
                        id="polar"
                        title={labels.steps.treatments.polar.title}
                        isVisible={polarOptions.length > 0}
                        handleLearnMore={props.handleLearnMore}
                        treatmentType={isGVP ? 'treatment' : 'polar'}
                        treatmentGroup="polar"
                        isLearnMore={props.isLearnMore}
                        disabled={isInsuranceLoading}
                    >
                        <StepRadioGroup
                            key="polarRadioGroup"
                            id="polarRadioGroup"
                            group={isGVP ? 'treatment' : 'polar'}
                            options={polarOptions}
                            handleChange={(polarKey, polarOptionId, polarPackage) => {
                                const polarOptionKey =
                                    polarPackage.frame.promoType === constants.promoTypes.GVP
                                        ? 'treatment'
                                        : 'polar';
                                handleToggleTreatmentOption(
                                    {
                                        [polarOptionKey]: polarOptionId,
                                    },
                                    polarPackage
                                );
                            }}
                            isLearnMore={props.isLearnMore}
                            firstLearnMoreTreatment={props.firstLearnMoreTreatment}
                            isMobile={props.isMobile}
                            settings={props.settings}
                            config={props.config}
                        />
                    </SubStep>
                ) : null}
                {arOptions && (!props.isLearnMore || props.showOnly === 'antiReflective') ? (
                    <SubStep
                        key="antiReflective"
                        id="antiReflective"
                        title={labels.steps.treatments.antiReflective.title}
                        isVisible={arOptions.length > 0}
                        handleLearnMore={props.handleLearnMore}
                        treatmentType={isGVP ? 'treatment' : 'antiReflective'}
                        treatmentGroup="antiReflective"
                        isLearnMore={props.isLearnMore}
                        disabled={isInsuranceLoading}
                    >
                        <StepRadioGroup
                            key="antiReflectiveRadioGroup"
                            id="antiReflectiveRadioGroup"
                            group={isGVP ? 'treatment' : 'antiReflective'}
                            options={arOptions}
                            handleChange={(arKey, arOptionId, arPackage) => {
                                const arOptionKey =
                                    arPackage.frame.promoType === constants.promoTypes.GVP
                                        ? 'treatment'
                                        : 'antiReflective';
                                handleToggleTreatmentOption(
                                    {
                                        [arOptionKey]: arOptionId,
                                    },
                                    arPackage
                                );
                            }}
                            isLearnMore={props.isLearnMore}
                            firstLearnMoreTreatment={props.firstLearnMoreTreatment}
                            isMobile={props.isMobile}
                            settings={props.settings}
                            config={props.config}
                        />
                    </SubStep>
                ) : null}
                {blueLightOptions && (!props.isLearnMore || props.showOnly === 'blueLight') ? (
                    <SubStep
                        key="blueLight"
                        id="blueLight"
                        title={labels.steps.treatments.blueLight.title}
                        isVisible={blueLightOptions.length > 0}
                        handleLearnMore={props.handleLearnMore}
                        treatmentType={isGVP ? 'treatment' : 'blueLight'}
                        treatmentGroup="blueLight"
                        isLearnMore={props.isLearnMore}
                        disabled={isInsuranceLoading}
                    >
                        <StepRadioGroup
                            key="blueLightRadioGroup"
                            id="blueLightRadioGroup"
                            group={isGVP ? 'treatment' : 'blueLight'}
                            options={blueLightOptions}
                            handleChange={(blueLightKey, blueLightOptionId, blueLightPackage) => {
                                const blueLightOptionKey =
                                    blueLightPackage.frame.promoType === constants.promoTypes.GVP
                                        ? 'treatment'
                                        : 'blueLight';
                                handleToggleTreatmentOption(
                                    {
                                        [blueLightOptionKey]: blueLightOptionId,
                                    },
                                    blueLightPackage
                                );
                            }}
                            isLearnMore={props.isLearnMore}
                            firstLearnMoreTreatment={props.firstLearnMoreTreatment}
                            isMobile={props.isMobile}
                            settings={props.settings}
                            config={props.config}
                        />
                        {props.isLearnMore &&
                        blueLightOptions[0] &&
                        !blueLightOptions[0].isLensGaming ? (
                            <div
                                className="blue-disclaimer"
                                dangerouslySetInnerHTML={{ __html: blueDisclaimer }}
                            />
                        ) : null}
                    </SubStep>
                ) : null}
                {transitionOptions && (!props.isLearnMore || props.showOnly === 'transition') ? (
                    <SubStep
                        key="transition"
                        id="transition"
                        title={labels.steps.treatments.transition.title}
                        isVisible={transitionOptions.length > 0}
                        handleLearnMore={props.handleLearnMore}
                        treatmentType={isGVP ? 'treatment' : 'transition'}
                        treatmentGroup="transition"
                        isLearnMore={props.isLearnMore}
                        disabled={isInsuranceLoading}
                    >
                        <StepRadioGroup
                            key="transitionRadioGroup"
                            id="transitionRadioGroup"
                            group={isGVP ? 'treatment' : 'transition'}
                            options={transitionOptions}
                            handleChange={(
                                transitionKey,
                                transitionOptionId,
                                transitionPackage
                            ) => {
                                const isGVPPackage =
                                    isGVP &&
                                    transitionPackage.frame.promoType === constants.promoTypes.GVP;
                                const transitionOptionKey = isGVPPackage
                                    ? 'treatment'
                                    : 'transition';
                                handleToggleTreatmentOption(
                                    {
                                        [transitionOptionKey]: transitionOptionId,
                                    },
                                    transitionPackage
                                );
                            }}
                            handleAddColor={() => {
                                props.handleSetSelectedOption(treatmentOptions);
                            }}
                            isLearnMore={props.isLearnMore}
                            isBlueLightSelected={isBlueLightOnly}
                            firstLearnMoreTreatment={props.firstLearnMoreTreatment}
                            isMobile={props.isMobile}
                            settings={props.settings}
                            config={props.config}
                        />
                    </SubStep>
                ) : null}
                {colorCategoryOptions &&
                (!props.isLearnMore || props.showOnly === 'colorCategory') ? (
                    <SubStep
                        key="colorCategory"
                        id="colorCategory"
                        title={labels.steps.treatments.colorCategory.title}
                        isVisible={colorCategoryOptions.length > 0}
                        handleLearnMore={props.handleLearnMore}
                        treatmentType={isGVP ? 'treatment' : 'colorCategory'}
                        treatmentGroup="colorCategory"
                        isLearnMore={props.isLearnMore}
                        disabled={isInsuranceLoading}
                    >
                        <StepRadioGroup
                            key="colorCategoryRadioGroup"
                            id="colorCategoryRadioGroup"
                            group={isGVP ? 'treatment' : 'colorCategory'}
                            options={colorCategoryOptions}
                            handleChange={(
                                colorCategoryKey,
                                colorCategoryOptionId,
                                colorCategoryPackage
                            ) => {
                                const colorCategoryOptionKey =
                                    colorCategoryPackage.frame.promoType ===
                                    constants.promoTypes.GVP
                                        ? 'treatment'
                                        : 'colorCategory';
                                handleToggleTreatmentOption(
                                    {
                                        [colorCategoryOptionKey]: colorCategoryOptionId,
                                    },
                                    colorCategoryPackage
                                );
                            }}
                            handleAddColor={() => {
                                props.handleSetSelectedOption(treatmentOptions);
                            }}
                            isLearnMore={props.isLearnMore}
                            firstLearnMoreTreatment={props.firstLearnMoreTreatment}
                            isMobile={props.isMobile}
                            settings={props.settings}
                            config={props.config}
                        />
                    </SubStep>
                ) : null}
                {!props.isLearnMore && (
                    <GenericButton
                        className="filling-button apply-treatments-button"
                        tabIndex={isLearnMoreModalOpen ? '-1' : '0'}
                        title={
                            treatmentOptions != null &&
                            currentLensPackage != null &&
                            baseLensPackage != null &&
                            currentLensPackage.lensPackage.upc !== baseLensPackage.lensPackage.upc
                                ? labels.steps.treatments.applyAndContinue
                                : labels.steps.treatments.continue
                        }
                        handleClick={() => {
                            treatmentOptions !== null
                                ? props.handleSetSelectedOption(treatmentOptions)
                                : handleNoTreatments();
                        }}
                        disabled={isInsuranceLoading}
                        dataElementId="X_X_LensPanel_Treatment-Choose"
                        dataDescription={treatmentDataDescription(treatmentOptions)}
                    >
                        {treatmentOptions != null &&
                        currentLensPackage != null &&
                        baseLensPackage != null &&
                        currentLensPackage.lensPackage.upc !== baseLensPackage.lensPackage.upc
                            ? labels.steps.treatments.applyAndContinue
                            : labels.steps.treatments.continue}
                    </GenericButton>
                )}
            </>
        );
    };

    return (
        <Step
            key="treatments"
            id="treatments"
            config={props.config}
            isVisible={true}
            isOpen={props.isOpen}
            isConfirmed={props.isConfirmed}
            confirmedSelection={props.confirmedSelection}
            hasLearnMore={false}
            handleEdit={props.handleEdit}
            handleLearnMore={props.handleLearnMore}
            handleBackClick={props.handleBackClick}
            isLearnMore={props.isLearnMore}
        >
            {props.isOpen && renderContent()}
        </Step>
    );
};

export default TreatmentStep;
